export default __webpack_public_path__ + "static/media/JujuyUnida.a750a002.png";